import { BleClient } from '@capacitor-community/bluetooth-le';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { useUser } from '../user.store';
import { isPlatform } from '@ionic/vue';
import { captureException } from '@sentry/vue';

export const useBlePermission = defineStore('ble-permission', () => {
  const user = useUser();
  const isOn = ref(false);
  const initialized = ref(false);

  const ready = computed(() => isOn.value && initialized.value);

  async function onAppResume() {
    if (!isPlatform('hybrid')) {
      console.log('WEB BLE NOT IMPLEMENTED, DISABLING');
      isOn.value = false;
      initialized.value = false;
      return;
    }

    console.log('Checking bluetooth on...');
    if (await user.shouldRedirectToPermissions()) {
      initialized.value = false;
      return;
    }
    await initialize();
    if (initialized.value) {
      try {
        isOn.value = await BleClient.isEnabled();
        console.log('BLE isOn', isOn.value);
      } catch (e) {
        console.error('Error checking if BLE is on', e);
        isOn.value = false;
        captureException(e);
      }
    }
  }

  async function initialize() {
    if (!initialized.value) {
      console.log('INITIALIZING BLE');
      try {
        await BleClient.initialize();
        console.log('SUCCESSFULLY INITIALIZED BLE');
        isOn.value = await BleClient.isEnabled();
      } catch (e) {
        console.log(e);
      }
      initialized.value = true;
    }
  }

  return {
    onAppResume,
    initialize,
    initialized,
    isOn,
    ready,
  };
});
